import React, { FunctionComponent } from 'react'
import { SVGProps } from 'interfaces'

const SVG: FunctionComponent<SVGProps> = ({ className }) => (
    <svg width='100%' className={className} viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'>
        <path
            opacity='0.4'
            fillRule='evenodd'
            clipRule='evenodd'
            d='M12.3568 10.0002L19.5117 2.84536C20.1633 2.1937 20.1633 1.14039 19.5117 0.48874C18.86 -0.162913 17.8067 -0.162913 17.1551 0.48874L10.0002 7.64359L2.84536 0.48874C2.1937 -0.162913 1.14039 -0.162913 0.48874 0.48874C-0.162913 1.14039 -0.162913 2.1937 0.48874 2.84536L7.64359 10.0002L0.48874 17.1551C-0.162913 17.8067 -0.162913 18.86 0.48874 19.5117C0.813733 19.8367 1.24039 20 1.66705 20C2.09371 20 2.52036 19.8367 2.84536 19.5117L10.0002 12.3568L17.1551 19.5117C17.4801 19.8367 17.9067 20 18.3334 20C18.76 20 19.1867 19.8367 19.5117 19.5117C20.1633 18.86 20.1633 17.8067 19.5117 17.1551L12.3568 10.0002Z'
            fill='#222222'
        />
    </svg>
)

export default SVG
